import React from "react"
import { useMatch, Link } from "react-router-dom"
import { routes } from "router/routes"
import { Flex, Space } from "antd"
import { Text, Title } from "ui/Typography"
import { SettingOutlined } from "@ant-design/icons"
import styles from "./index.module.css"
import { corners } from "themes/variables"

export const ClientsBreadcrumb = () => {
  const matchDetail = useMatch(routes.guideClientPath())
  const matchEdit = useMatch(routes.guideClientEditPath())
  const isDetail = !!matchDetail || !!matchEdit

  return (
    <Space className="mb-4xl w-full" gap={corners.S} align="center">
      <div>
        <SettingOutlined />
      </div>
      <Link to={routes.guideClientsPath()} style={{ textDecoration: "none" }}>
        <Title level={5} className={`${styles.clientHeaderTitle} ${isDetail ? styles.colorPrimary : ""}`}>
          Clients
        </Title>
      </Link>
      {isDetail && (
        <Flex gap={corners.S} align="center">
          <Text size="lg" className={styles.clientHeaderTitle}>
            ·
          </Text>
          <Text size="lg" className={styles.clientHeaderTitle}>
            Client Details
          </Text>
        </Flex>
      )}
    </Space>
  )
}
